// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Profile_container__6poVI{
    display: flex;
    min-height: calc(100vh - 210px);
    width: 866px;
    margin: 20px auto;
    left: 0;
    right: 0;
    background-color: #FFFFFF;
    border-radius: 30px;
    box-shadow: 0 3px 12px 0 #40798C12;
}
@media(max-width: 930px){
    .Profile_container__6poVI{
        width: 100%;
    }
}
@media(max-width: 700px){
    .Profile_container__6poVI{
        min-height: calc(100vh - 190px);
    }
}
.Profile_menu__xAkuw{
    padding: 37px 0;
    border-right: 1px solid #1F363D1A;
}
@media(max-width: 700px){
    .Profile_menu__xAkuw{
        display: none;
    }
}
.Profile_menuLink__tNmEs{
    display: flex;
    width: 240px;
    margin-bottom: 32px;
    padding: 2px 25px;
    color: #1F363D;
    background-color: #FFFFFF;
    font-size: 16px;
    font-family: 'Gotham Medium', serif;
    border: none;
    cursor: pointer;
}
.Profile_menuLink__tNmEs:focus-visible{
    outline: none;
}
.Profile_selected__YV00T{
    padding-left: 20px;
    color: #274C77;
    border-left: 5px solid #274C77;
}
.Profile_menuLinkIcon__o-DEl{
    position: relative;
    top: -1px;
    height: 20px;
    width: 20px;
    margin-right: 15px;
}
.Profile_views__3tKvX{
    width: calc(100% - 80px);
    padding: 35px 40px;
    overflow-x: hidden;
}
@media(max-width: 700px){
    .Profile_views__3tKvX{
        width: calc(100% - 40px);
        padding: 35px 20px;
    }
}
.Profile_menuDropdown__8eHut{
    display: none;
    margin-bottom: 25px;
    z-index: 200;
}
@media(max-width: 700px){
    .Profile_menuDropdown__8eHut{
        display: block;
    }
}
.Profile_personalInfo__1yDao, .Profile_organizationInfo__9mK3C, .Profile_requests__WK9\\+u, .Profile_security__Yaz1x{
    z-index: 100;
}
@media(max-width: 700px){
    .Profile_security__Yaz1x{
        margin-top: 60px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Profile.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,+BAA+B;IAC/B,YAAY;IACZ,iBAAiB;IACjB,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI;QACI,WAAW;IACf;AACJ;AACA;IACI;QACI,+BAA+B;IACnC;AACJ;AACA;IACI,eAAe;IACf,iCAAiC;AACrC;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,mCAAmC;IACnC,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI;QACI,wBAAwB;QACxB,kBAAkB;IACtB;AACJ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI,YAAY;AAChB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".container{\n    display: flex;\n    min-height: calc(100vh - 210px);\n    width: 866px;\n    margin: 20px auto;\n    left: 0;\n    right: 0;\n    background-color: #FFFFFF;\n    border-radius: 30px;\n    box-shadow: 0 3px 12px 0 #40798C12;\n}\n@media(max-width: 930px){\n    .container{\n        width: 100%;\n    }\n}\n@media(max-width: 700px){\n    .container{\n        min-height: calc(100vh - 190px);\n    }\n}\n.menu{\n    padding: 37px 0;\n    border-right: 1px solid #1F363D1A;\n}\n@media(max-width: 700px){\n    .menu{\n        display: none;\n    }\n}\n.menuLink{\n    display: flex;\n    width: 240px;\n    margin-bottom: 32px;\n    padding: 2px 25px;\n    color: #1F363D;\n    background-color: #FFFFFF;\n    font-size: 16px;\n    font-family: 'Gotham Medium', serif;\n    border: none;\n    cursor: pointer;\n}\n.menuLink:focus-visible{\n    outline: none;\n}\n.selected{\n    padding-left: 20px;\n    color: #274C77;\n    border-left: 5px solid #274C77;\n}\n.menuLinkIcon{\n    position: relative;\n    top: -1px;\n    height: 20px;\n    width: 20px;\n    margin-right: 15px;\n}\n.views{\n    width: calc(100% - 80px);\n    padding: 35px 40px;\n    overflow-x: hidden;\n}\n@media(max-width: 700px){\n    .views{\n        width: calc(100% - 40px);\n        padding: 35px 20px;\n    }\n}\n.menuDropdown{\n    display: none;\n    margin-bottom: 25px;\n    z-index: 200;\n}\n@media(max-width: 700px){\n    .menuDropdown{\n        display: block;\n    }\n}\n.personalInfo, .organizationInfo, .requests, .security{\n    z-index: 100;\n}\n@media(max-width: 700px){\n    .security{\n        margin-top: 60px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Profile_container__6poVI`,
	"menu": `Profile_menu__xAkuw`,
	"menuLink": `Profile_menuLink__tNmEs`,
	"selected": `Profile_selected__YV00T`,
	"menuLinkIcon": `Profile_menuLinkIcon__o-DEl`,
	"views": `Profile_views__3tKvX`,
	"menuDropdown": `Profile_menuDropdown__8eHut`,
	"personalInfo": `Profile_personalInfo__1yDao`,
	"organizationInfo": `Profile_organizationInfo__9mK3C`,
	"requests": `Profile_requests__WK9+u`,
	"security": `Profile_security__Yaz1x`
};
export default ___CSS_LOADER_EXPORT___;
